import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    extractHtmlInnerText,
    getArrIndexValue,
    getArrLen,
    getCurrUrlMainDomain,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {
    EVENT_INPUT_MAX_LEN,
    GenRouteUrls,
    Keys,
    ModuleFieldsData,
    ModuleRouteUrls,
    Modules,
    ReqUrls,
    ShareFeatureModules,
    ShowViewType,
    SurveyDateTimeTypes as DATE_TIME_TYPES,
    SurveyQTypes as Q_TYPES,
} from "../../../config/AppConfig";
import {Checkbox, Flexbox, HorDiv, Label, LikertView, MsgBox, NullMsgLabel} from "../../../../common/fusion-ui";
import {CssVariant, DefStrNA, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useConfig} from "../../../context/ConfigProvider";

const Survey_ViewPage = React.memo(({
                                        open,
                                        onHide,
                                        recordId,
                                        showAs = ShowViewType.PAGE,
                                        onSuccess,
                                    }) => {
    const TAG = "Survey_ViewPage";

    const moduleName = Modules.Survey;

    const mf = ModuleFieldsData[Modules.Survey_ViewQs];
    const mf_srv = ModuleFieldsData[Modules.Survey];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {updateConfig} = useConfig();

    const FOCUS_DELAY = 2000;

    const Fields = {
        surveyId: 'surveyId',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [qRecords, setQRecords] = useState([]);
    // const [qRecords, setQRecords] = useState(Survey_ViewPage_Data);
    const [srvRecordData, setSrvRecordData] = useState({});

    useEffect(() => {
        // log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            const recordId = getCurrUrlParamValue('id');
            // log('useEffect.showAs->PAGE:', showAs, 'recordId:', recordId);
            fetchPageData(recordId);
        } else {
            if (checkNullStr(recordId)) {
                log('useEffect.showAs-Popup->', 'recordId:', recordId);
                fetchPageData(recordId);
            }
        }
    }, [recordId, showAs]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={Modules.Survey_ViewQs}
            addPageTitle={getTabTitle()}
            editPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            backUrl={ModuleRouteUrls[moduleName]}
            open={open}
            showShare={ShareFeatureModules.some((item) => item.tag == TAG)}
            shareUrl={`${getCurrUrlMainDomain()}${GenRouteUrls.survey_viewSurveyPage}${getField(Fields.surveyId)}`}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
            }}
            showAs={showAs}
            md={7}
        >
            <div>
                <div className={`h-auto m-0 p-0 mt-2x`}>
                    {/*survey-name*/}
                    <div>
                        <Label className={`m-0 p-0 text-wrap fw-semi-bold x`} textAt={'start'} color={theme.text60}>
                            <span>Survey Topic:</span>
                            <span className={'text-primary ps-1 fw-bold'}>
                            {getJsonValue(srvRecordData, mf_srv.title.column)}
                    </span>
                        </Label>
                    </div>
                    {/*survey-msg*/}
                    <div className={'mt-2'}>
                        <p className={'m-0 p-0 text-block text-wrap'} style={{color: theme.text80}}>
                            {`Thank you for taking the time to participate in this "${getJsonValue(srvRecordData, mf_srv.title.column)}". Your comments will enable us to better plan and execute future events and customize them to meet your needs.`}
                        </p>
                    </div>

                    <div className={'w-100 m-0 p-0 mt-2'}>
                        {/*q-items*/}
                        <div style={{color: theme.text}}>{
                            checkNullArr(qRecords)
                                ? qRecords.map((item, index) => {
                                    return <div key={index + 'dfgtr545'}>
                                        {createSingleQBox(item, index)}
                                        {(index < getArrLen(qRecords, 0) - 1) && <HorDiv variant={theme.text20}/>}
                                    </div>
                                })
                                : <NullMsgLabel color={theme.text50}>No questions available!</NullMsgLabel>}</div>

                        {/*submit, cancel controls*/}
                        <div className={'mt-3'}>
                            {/*msg-box*/}
                            {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                                {getField(Fields.panelMsg)}
                            </MsgBox>}

                            <Flexbox justifyAt={'center'} alignAt={'center'}>
                                {/*cancel*/}
                                {(showAs == ShowViewType.DRAWER || showAs == ShowViewType.DIALOG) && <ThemedButton
                                    className={'rounded-2 w-auto px-4 py-1'}
                                    text={'Cancel'}
                                    variant={theme.text10}
                                    hoverBgColor={theme.text30}
                                    color={theme.text}
                                    onClick={() => {
                                        if (onHide) onHide();
                                        clearPanelData();
                                    }}
                                    mx={2}
                                />}

                                {/*submit*/}
                                <ThemedButton
                                    className={'rounded-2 w-auto px-4 py-1'}
                                    text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Submitting...' : 'Submit'}
                                    variant={theme.primaryBlue}
                                    hoverBgColor={theme.primaryBlueDark}
                                    loadingWidth={'auto'}
                                    asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                                    disabled={isFieldTrue(Fields.submitBtn_disabled) || !checkNullArr(qRecords) || !checkNullJson(srvRecordData)}
                                    onClick={handleSubmit}
                                    mx={2}
                                />
                            </Flexbox>
                        </div>
                    </div>
                </div>
            </div>
        </FormPageRoot>
    </>);

    function createSingleQBox(item, index) {
        return <div className={'pt-2 pb-1'}>
            {/*question*/}
            <div>
                <Label className={'fw-semi-bold p-0 m-0 text-wrap'} textAt={'start'}>
                    <span className={'fw-normal'}>Question {index + 1}: </span>
                    <span>{getItemField(mf.question)}</span>
                </Label>
            </div>

            {/*answer*/}
            <div>
                <div className={'fw-semi-bold'}>Answer:</div>
                {/*<div>Answer-type: {getItemField(mf.answerType)}</div>*/}

                <div className={'px-2 mt-1x'}>
                    <div className={''}>
                        {/*text-area | paragraph*/}
                        {(getItemField(mf.answerType) == Q_TYPES.textarea.value || getItemField(mf.answerType) == Q_TYPES.paragraph.value) &&
                            <div>
                                <ThemedInput
                                    wrapperClassName={'w-100'}
                                    type={'text'}
                                    placeholder={'Your answer'}
                                    label={''}
                                    id={mf.answerType_AnsValue}
                                    value={getItemField(mf.answerType_AnsValue)}
                                    showLimitLabel={true}
                                    maxLength={EVENT_INPUT_MAX_LEN}
                                    asTextArea={true}
                                    style={{
                                        height: '120px',
                                        maxHeight: '120px',
                                        minHeight: '120px',
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        updateItemField(mf.answerType_AnsValue, value);
                                    }}
                                />
                            </div>}

                        {/*sliderRange*/}
                        {(getItemField(mf.answerType) == Q_TYPES.sliderRange.value) &&
                            <Flexbox className={'mt-1'} alignAt={'center'} justifyAt={'start'}>
                                {/* start-range */}
                                <ThemedInput
                                    mainWrapperClassName={'me-2'}
                                    wrapperClassName={''}
                                    className={''}
                                    label={'Start Range'}
                                    placeholder={'Enter Start Range'}
                                    id={mf.rangeStart}
                                    type={'text'}
                                    // pattern={Patterns.plainNumber}
                                    // validate={true}
                                    // value={getItemField(mf.rangeStart)}
                                    value={getItemField(mf.answerType_AnsValue)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // updateItemField(mf.rangeStart, value);
                                        updateItemField(mf.answerType_AnsValue, value);
                                    }}
                                />

                                {/* end-range */}
                                <ThemedInput
                                    mainWrapperClassName={'ms-2'}
                                    className={''}
                                    label={'End Range'}
                                    placeholder={'Enter End Range'}
                                    id={mf.rangeEnd}
                                    type={'text'}
                                    // pattern={Patterns.plainNumber}
                                    // validate={true}
                                    // value={getItemField(mf.rangeEnd)}
                                    value={getItemField(mf.answerType_AnsValue2)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // updateItemField(mf.rangeEnd, value);
                                        updateItemField(mf.answerType_AnsValue2, value);
                                    }}
                                />
                            </Flexbox>}

                        {/*date-time*/}
                        {(getItemField(mf.answerType) == Q_TYPES.dateTime.value) &&
                            <div>
                                {Object.values(DATE_TIME_TYPES).map((dtItem, dtIndex) => {
                                    return <Checkbox
                                        key={dtIndex + dtItem}
                                        wrapperClassName={`w-100 mb-1`}
                                        className={``}
                                        type={'radio'}
                                        labelStyle={{color: theme.text}}
                                        defaultChecked={getItemField(mf.answerType_AnsValue) == dtItem}
                                        checked={getItemField(mf.answerType_AnsValue) == dtItem}
                                        onChange={(e, checked) => {
                                            // updateItemField(mf.answerType_dateTimeType, dtItem);
                                            updateItemField(mf.answerType_AnsValue, dtItem);
                                            updateItemField(mf.answerType_AnsValue_Index, dtIndex);
                                        }}>{dtItem}</Checkbox>
                                })}

                            </div>}

                        {/*radio-list | cb-list*/}
                        {(getItemField(mf.answerType) == Q_TYPES.multipleChoice.value || (getItemField(mf.answerType) == Q_TYPES.checkboxes.value)) &&
                            <div>
                                {checkNullArr(getItemField(mf.answerType_multipleChoice))
                                    ? getItemField(mf.answerType_multipleChoice).map((cbItem, cbIndex) => {
                                        return <Checkbox
                                            key={cbIndex + getJsonValue(cbItem, 'name')}
                                            wrapperClassName={`w-100 mb-1`}
                                            className={``}
                                            type={getItemField(mf.answerType) == Q_TYPES.multipleChoice.value ? 'radio' : 'checkbox'}
                                            labelStyle={{color: theme.text}}
                                            defaultChecked={getItemField(mf.answerType_AnsValue) == getJsonValue(cbItem, 'name')}
                                            checked={getItemField(mf.answerType_AnsValue) == getJsonValue(cbItem, 'name')}
                                            onChange={(e, checked) => {
                                                // updateItemField(mf.answerType_multipleChoice, getJsonValue(cbItem, 'name'));
                                                updateItemField(mf.answerType_AnsValue, getJsonValue(cbItem, 'name'));
                                                updateItemField(mf.answerType_AnsValue_Index, cbIndex);
                                            }}>{getJsonValue(cbItem, 'name', DefStrNA)}</Checkbox>
                                    }) : <NullMsgLabel textAt={'start'} color={theme.text50}>No options available!</NullMsgLabel>}
                            </div>}

                        {/*likert*/}
                        {(getItemField(mf.answerType) == Q_TYPES.likert.value) &&
                            <div>
                                <LikertView
                                    className={``}
                                    data={getItemField(mf.answerType_Likert_LikertData, [])}
                                    previewMode={true}
                                    borderColor={theme.text20}
                                    color={theme.text}
                                    roundedVariant={3}
                                    onPreviewUpdate={(updatedData, optionIndex) => {
                                        printLog('createLikertChoice.LikertView.onPreviewUpdate.updatedData:', updatedData);
                                        try {
                                            if (checkNullJson(updatedData)) {
                                                const formattedData = Object.entries(updatedData)
                                                    .map(([key, value]) => `${key}|${value}`)
                                                    .join(',').toString();

                                                updateItemField(mf.answerType_AnsValue, formattedData);
                                                updateItemField(mf.answerType_AnsValue_Index, optionIndex);
                                                printLog('createLikertChoice.LikertView.onPreviewUpdate.formattedData:', formattedData, 'optionIndex:', optionIndex);
                                            }
                                        } catch (e) {
                                            console.error(e)
                                        }
                                    }}
                                />
                            </div>}
                    </div>

                    <div>
                        {(getItemField(mf.answerType) != Q_TYPES.textarea.value
                                && getItemField(mf.answerType) != Q_TYPES.paragraph.value
                                && getItemField(mf.answerType) != Q_TYPES.sliderRange.value
                                && getItemField(mf.answerType) != Q_TYPES.dateTime.value
                                && getItemField(mf.answerType) != Q_TYPES.multipleChoice.value
                                && getItemField(mf.answerType) != Q_TYPES.checkboxes.value
                                && getItemField(mf.answerType) != Q_TYPES.likert.value)
                            && <Label className={'m-0 p-0 px-2 py-1 bg-warning-25 border-1 border-warning text-warning-dark'}
                                      textAt={'start'} iconClass={'bi bi-exclamation-circle me-1'}>
                                Unsupported type of answer!
                            </Label>}
                    </div>
                </div>
            </div>
        </div>


        function getItemField(colField, defValue) {
            // return getJsonValue(item, colField.column, defValue);
            return getJsonValue(getArrIndexValue(qRecords, index, {}), colField.column, defValue);
        }

        function updateItemField(colField, value) {
            const updatedList = [...qRecords];
            updatedList[index][colField.column] = value;
            // log('colField.column:', colField.column, 'value:', value, 'updatedList:', updatedList);
            setQRecords(updatedList);

            // setQuestionState((current) =>
            //     current.map((obj) => {
            //         return obj.questionId == q.id
            //             ? {...obj, likert_ans: formattedData.toString(), value_ansId: ""}
            //             : obj;
            //     })
            // );
        }
    }

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'qRecords:', qRecords);
        try {
            let allFieldsChecked = qRecords.some(item => checkNullStr(getJsonValue(item, mf.answerType_AnsValue.column)));
            if (!allFieldsChecked) {
                toast("Please take a moment to complete some of the survey questions. Your feedback is invaluable to us!", CssVariant.danger);
                // toast("Help us improve our survey by answering a few questions. Thank you for your participation!", CssVariant.danger);
                // toast("Your feedback makes a difference! Take a moment to answer a few survey questions.", CssVariant.danger);
                return false;
            }

            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    surveyId: getField(Fields.surveyId),
                    qRecords: qRecords,
                };
                sendRequest({
                    reqUrl: ReqUrls.survey__viewSurveyPage_submitQsResponses,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            updateField(Fields.isDataFetched, true);
            log(fun, 'recordId:', recordId);
            if (checkNullStr(recordId)) {
                setQRecords([]);
                setSrvRecordData({});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");

                const REQUEST_OPTIONS = {
                    recordId: recordId,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.survey__viewQsPage_fetch_SurveyQs,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const srvRecord = getJsonValueFromNestedKeys(fetchedData, ['data', 'surveyRecord'], {});
                            const qRecords = getJsonValueFromNestedKeys(fetchedData, ['data', 'qRecords'], []);
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            if (success) {
                                // toast(message, CssVariant.success);
                                setQRecords(qRecords);
                                setSrvRecordData(srvRecord);
                                updateField(Fields.surveyId, getJsonValue(srvRecord, mf_srv.recordId.column));

                                updateConfig(Keys.sharePanel_recordTitle, getJsonValue(srvRecord, mf_srv.title.column));
                                updateConfig(Keys.sharePanel_recordDescription, extractHtmlInnerText(getJsonValue(srvRecord, mf_srv.desc.column)));
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                            }
                            updateField(Fields.isDataFound, success);
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                window.location.href = ModuleRouteUrls[moduleName];
            }, 2500);
        }, 500);
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getTabTitle() {
        return `View Survey Questions`;
    }

    function clearPanelData() {
        setQRecords({});
        setSrvRecordData({});
        setFieldsData({});
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Survey_ViewPage;
